module.exports = __webpack_public_path__ + "img/hazratMasoomeDetails.7dfeba70.png";